import React, { useState, useContext, useEffect } from 'react';
import { Navbar, Nav, Container, Modal, Form, NavDropdown } from 'react-bootstrap';
import { AuthContext } from '../context/AuthContext';
import { showSweetAlert } from '../components/SweetAlert';
import { NavLink, useNavigate } from 'react-router-dom';

function LimitedHeader() {
  const [showSupport, setShowSupport] = useState(false);
  const [issueType, setIssueType] = useState('');
  const [description, setDescription] = useState('');
  const { supportEmail, fetchUserData } = useContext(AuthContext)
  const [name] = useState("");
  const [errors, setErrors] = useState({ issueType: '', description: '' });

  const handleShowSupport = () => setShowSupport(true);
  const handleCloseSupport = () => setShowSupport(false);
  const navigate = useNavigate();

  const handleLogout = () => {
    localStorage.clear();
    navigate('/');
  };
  const token = localStorage.getItem('accessToken');

  useEffect(() => {
    if(token){
      fetchUserData();
    }
  }, [fetchUserData, token]);

  const handleSubmit =async (event) => {
    event.preventDefault();

    let valid = true;
    let newErrors = { ...errors };

    if (!issueType) {
      console.log('no email');
      newErrors.issueType = 'Select any one issue';
      valid = false;
    } else if (!description) {
        console.log('no email');
        newErrors.description = 'Description is required.';
        valid = false;
    }else {
        newErrors.issueType = '';
        newErrors.description = '';
    }
    setErrors(newErrors);

    console.log('Submitting issue:', {
      issueType,
      description,
    });

    if (valid) {
      const response = await supportEmail(issueType, description);
      if(response?.message === "Email sent successfully."){
          handleCloseSupport(); 
          showSweetAlert('Success!', `Email send Successfully.`, 'success');
      }
      else{
        showSweetAlert('Warning!', `Email address is not verified.`, 'warning');
      }
     }
  };

  return (
    <>
      <Navbar expand="lg">
        <Container fluid>
          <Navbar.Brand ><img src={`${process.env.PUBLIC_URL}/images/No Doji 1.svg`} className="header-logo" alt="logo" /></Navbar.Brand>
          <Navbar.Toggle aria-controls="basic-navbar-nav" />
          <Navbar.Collapse id="basic-navbar-nav">
            <Nav className="me-auto">
              <Nav.Link className="nav-link" as={NavLink}>
                Home
              </Nav.Link>
              <Nav.Link>Portfolio</Nav.Link>
            </Nav>
            <Nav className="ml-auto right-nav">
              <Nav.Link><img src={`${process.env.PUBLIC_URL}/images/bar.svg`} alt="bar-icon"/></Nav.Link>
              <Nav.Link><img src={`${process.env.PUBLIC_URL}/images/message.svg`} alt="message-icon" onClick={handleShowSupport} /></Nav.Link>
              <Nav.Link><img src={`${process.env.PUBLIC_URL}/images/setting.svg`} alt="setting-icon"/></Nav.Link>
              {/* <div style={{padding: '12px 8px 0px 15px'}}>
                <img 
                  src={`${process.env.PUBLIC_URL}/images/user-circle.svg`} 
                  alt="user-img" 
                />
              </div> */}
              <NavDropdown
                title={<img src={`${process.env.PUBLIC_URL}/images/user-circle.svg`} alt="user-img" />}
                id="settings-nav-dropdown"
                align="end" // Ensure dropdown aligns to the end
                menuVariant="dark"
              >
                
                <NavDropdown.Item onClick={handleLogout}>Logout</NavDropdown.Item>
              </NavDropdown>

            </Nav>
          </Navbar.Collapse>
        </Container>
      </Navbar>
      <Modal show={showSupport} onHide={handleCloseSupport} centered >
        <Modal.Body className="support-dialog">
          <img src={`${process.env.PUBLIC_URL}/images/close.png`} alt="close" className="close-icon" role="button" onClick={handleCloseSupport} />
          <h6 className="large-text">Hello {name}! <br />How can we help you today?</h6>
          <Form onSubmit={handleSubmit} className="basic-form">
            <Form.Group>
              <Form.Control
                as="select"
                className="form-input custom-select mt-4" // Apply custom CSS class
                value={issueType}
                onChange={(e) => {
                  setIssueType(e.target.value);
                  if (e.target.value) {
                    setErrors((prevErrors) => ({ ...prevErrors, issueType: '' })); // Remove error
                  }
                }}
              >
                <option value="">Select your type of issue</option>
                <option value="General Issues">General Issues</option>
                <option value="Technical Issues">Technical Issues</option>
                <option value="Misc. Support Issues">Misc. Support Issues</option>
              </Form.Control>
            </Form.Group>
            {errors.issueType && <div className="text-danger mt-1">{errors.issueType}</div>}

            <Form.Group>
              <Form.Control
                as="textarea"
                className="form-input mt-4 support-desc"
                placeholder="Description"
                value={description}
                rows={4}
                onChange={(e) => {
                  setDescription(e.target.value);
                  if (e.target.value.trim()) {
                    setErrors((prevErrors) => ({ ...prevErrors, description: '' })); // Remove error
                  }
                }}
              />
            </Form.Group>
            {errors.description && <div className="text-danger mt-1">{errors.description}</div>}

            <div className="row justify-content-center submit-btn">
              <button type="submit" className="w-55 p-2 theme-btn btn-primary" style={{ color: "#FFF", border: "unset" }}>Submit</button>
            </div>
          </Form>
        </Modal.Body>
      </Modal>
    </>
  );
}

export default LimitedHeader;
